









import { Component, Vue } from 'vue-property-decorator';
import Clean from '@/components/layouts/clean.vue';
import Default from '@/components/layouts/default.vue';
import Footer from '@/components/global/Footer.vue';

@Component({
  components: { 'default-layout': Default, 'clean-layout': Clean, 'sb-footer': Footer },
})
export default class App extends Vue {
  public defaultLayout = 'default';

  public get layout() {
    return `${this.$route.meta.layout || this.defaultLayout}-layout`;
  }

  public get hasTouch() {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  }
}
